import { OnboardingWizard } from '@/components/features/onboarding/OnboardingWizard';

/**
 * First-time onboarding page. Rendered full-screen (no AppLayout / navbar)
 * and reached only via the OnboardingGate redirect for users whose profile
 * has `onboarded === false`.
 */
export function OnboardingPage() {
  return <OnboardingWizard />;
}
